import axios from "axios";
import { baseURL } from "../utils/consts";

const updateTransferTicketStatus = async (eventId, uniqueHash, signedKey) => {
  const responseObject = {
    eventId,
    uniqueHash,
    signedKey,
  };

  try {
    const response = await axios.post(
      `${baseURL}/invitedVia/expressEntry/updateTransferedTicketInformationById`,

      responseObject,

      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.data.payLoad;
    return data;
  } catch (err) {
    throw err;
  }
};

export default updateTransferTicketStatus;
